import Vue from 'vue';
import Vuex, { Store } from "vuex";

Vue.use(Vuex)
const original = new Store<any>({})
export { original as store };